export function debugHistory(scope, message, extra = {}) {
    const state = window.history.state || null;
    const payload = {
        scope,
        message,
        path: window.location.pathname,
        search: window.location.search,
        hash: window.location.hash,
        historyLength: window.history.length,
        historyState: state,
        idx: typeof state?.idx === "number" ? state.idx : null,
        ts: new Date().toISOString(),
        ...extra,
    };

    console.log("[spa-debug]", payload);
}
